import React from 'react';
import { formatDate } from '../../utils/dateFormat';
import { detailLabel, detailValue } from './constants';

// The grey box at the top of each company tab on the Signed FS / QC35 forms:
// who leads the engagement, plus (FS only) the sign-off date on file. Shared
// by the workflow New pages and the Management record form.
const EngagementLeadsBox = ({ engagement, showSignOff = false }) => (
  <div className={`border border-slate-200 rounded-lg p-3 bg-slate-50 grid grid-cols-1 ${showSignOff ? 'sm:grid-cols-4' : 'sm:grid-cols-3'} gap-2 text-sm`}>
    <div><span className={detailLabel}>Partner</span><div className={detailValue}>{engagement.partner || '—'}</div></div>
    <div><span className={detailLabel}>Director</span><div className={detailValue}>{engagement.director || '—'}</div></div>
    <div><span className={detailLabel}>Manager</span><div className={detailValue}>{engagement.manager || '—'}</div></div>
    {showSignOff && (
      <div><span className={detailLabel}>Current Sign-Off</span><div className={detailValue}>{engagement.signOffDate ? formatDate(engagement.signOffDate) : '—'}</div></div>
    )}
  </div>
);

export default EngagementLeadsBox;
